import { ILibraryTopology, createComponentsRegistrySiteAssets } from '@wix/thunderbolt-components-registry/siteAssets'
import { componentsMappers } from '@wix/thunderbolt-components-native'
import type { ModuleFetcher, SiteAssetsHttpClient } from '@wix/thunderbolt-becky-types'
import { getEditorElementsAssetUrl } from '@wix/thunderbolt-commons'
import type { BeckyModel } from '../../types/becky'

const getTbElementsModule = async ({
	moduleFetcher,
	tbElementsSiteAssets,
	fileRepoUrl,
}: {
	moduleFetcher?: ModuleFetcher
	tbElementsSiteAssets?: string
	fileRepoUrl: string
}) => {
	if (!tbElementsSiteAssets || tbElementsSiteAssets === 'undefined' || !moduleFetcher) {
		return undefined
	}
	const fromUrl = getEditorElementsAssetUrl(tbElementsSiteAssets, fileRepoUrl)
	return moduleFetcher.fetch({ fromUrl })
}

export const getComponentMappers = async ({
	moduleFetcher,
	httpClient,
	tbElementsSiteAssets,
	fileRepoUrl,
	experiments,
	registryLibrariesTopology,
}: {
	httpClient: SiteAssetsHttpClient
	moduleFetcher?: ModuleFetcher
	tbElementsSiteAssets?: string
	fileRepoUrl: string
	experiments: BeckyModel['experiments']
	registryLibrariesTopology: string
}) => {
	/**
	 * Once registry experiment is merged, remove `if`
	 * https://jira.wixpress.com/browse/WCR-365
	 */
	if (experiments['specs.thunderbolt.componentsRegistry']) {
		const libraries: Array<ILibraryTopology> = JSON.parse(registryLibrariesTopology)

		const registry = await createComponentsRegistrySiteAssets({
			libraries,
			modulesLoader: {
				relativeUrl: () => {
					throw new Error('ModulesLoader `relativeUrl` method should not be used')
				},
				absoluteUrl: async (url) => {
					const response = await httpClient.fetch(url)
					return response.text() as any
				},
			},
		})

		const models = await registry.loadComponentMappers()

		return {
			...componentsMappers,
			...models,
		}
	} else {
		const module = await getTbElementsModule({ moduleFetcher, tbElementsSiteAssets, fileRepoUrl })
		const tbElementsMappers = module?.default ?? module
		return { ...componentsMappers, ...tbElementsMappers }
	}
}
